export const formatDate = (date: string | null): string => {
  if (!date || date === "undefined") return "";
  const [day, month, year] = date.split(" ")[0].split("/");
  const [hour, minute] = date.split(" ")[1].split(":");

  return `${day}/${month}/${year}, ${hour}:${minute} GMT`;
};
